import { cn } from "@/lib/utils";

/** Plan-Sarthi mark: blueprint grid + forward arrow. mono=true renders single-colour (currentColor). */
export const LogoMark = ({ className, mono = false }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="1.5" y="1.5" width="37" height="37" rx="3" stroke={mono ? "currentColor" : "#123A63"} strokeWidth="2.5" />
    <g stroke={mono ? "currentColor" : "#2C6BAF"} strokeWidth="1.2" opacity={mono ? 0.55 : 0.75}>
      <path d="M11 3v34M20 3v34M29 3v34M3 11h34M3 20h34M3 29h34" />
    </g>
    <path
      d="M9 27.5L24.5 12M24.5 12h-8.2M24.5 12v8.2"
      stroke={mono ? "currentColor" : "#F97316"}
      strokeWidth="4"
      strokeLinecap="square"
      strokeLinejoin="miter"
    />
  </svg>
);

export const Logo = ({ className, mono = false, size = "md", showSub = false }) => {
  const sizes = {
    sm: { mark: "w-6 h-6", text: "text-[13px]", sub: "text-[8px]" },
    md: { mark: "w-8 h-8", text: "text-[15px]", sub: "text-[9px]" },
    lg: { mark: "w-11 h-11", text: "text-xl", sub: "text-[10px]" },
  }[size];

  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <LogoMark className={sizes.mark} mono={mono} />
      <div className="leading-none">
        <div className={cn("font-display font-bold tracking-tight", sizes.text, mono ? "" : "text-foreground")}>
          Plan<span className={mono ? "" : "text-[#F97316]"}>-</span>Sarthi
        </div>
        {showSub ? (
          <div className={cn("uppercase tracking-[0.18em] mt-1", sizes.sub, mono ? "opacity-70" : "text-muted-foreground")}>
            EPC Execution Platform
          </div>
        ) : null}
      </div>
    </div>
  );
};

export const TAGLINE = "Plan Smarter. Build Stronger. Deliver on Time.";
export const SUB_TAGLINE = "India's first industrial EPC execution platform";
export const ABOUT_TEXT =
  "Plan-Sarthi is an advanced industrial project execution platform built for Engineering, Procurement, and Construction (EPC) professionals. Designed for Thermal Power Plants, T&D projects, and heavy infrastructure, Plan-Sarthi brings together S-Curve tracking, Daily Progress Reports (DPR), resource planning, and workforce management into one powerful digital workspace. We eliminate delays, reduce cost overruns, and give project managers total control over every milestone — from planning to commissioning. Backed by Sarthi Associates' deep domain expertise in industrial staffing and engineering consultancy, Plan-Sarthi is the trusted execution partner for India's most critical infrastructure projects.";
